import { render, staticRenderFns } from "./club-form.vue?vue&type=template&id=34f5031e&scoped=true"
import script from "./club-form.vue?vue&type=script&lang=js"
export * from "./club-form.vue?vue&type=script&lang=js"
import style0 from "./club-form.vue?vue&type=style&index=0&id=34f5031e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5031e",
  null
  
)

export default component.exports